// third-party
import { FormattedMessage } from "react-intl";

import {
  LocusOriginBotIcon,
  LocusChargersIcon,
  LocusDevicesIcon,
} from "assets/icons/LocusIcons.js";
import TvRoundedIcon from '@mui/icons-material/TvRounded';
import {
  ASSET_MANAGER,
  CROSS_SITE_VIEWER,
  LOCUS_ASSET_MANAGER,
  LOCUS_TENANT,
  VIEWER,
  LOCUS_CUSTOMER_USER_MANAGER,
  LOCUS_USER_MANAGER,
  SYSTEM_INTEGRATOR,
  LOCUS_TOOLS_ADMINISTRATOR,
  LOCUS_TOOLS_USER,
  LOCUS_CONFIGURATION_ADMIN,
  CONFIGURATION_ADMIN,
  USER_MANAGER,
  TOOLS_USER,
} from "../utils/constants/user";

// ==============================|| APPLICATION MENU ITEMS ||============================== //
/** @type {LocusMenuGroup} */
const assetManagement = {
  id: "asset-management",
  title: <FormattedMessage id="asset-management" />,
  type: "group",
  view: ["locus", "client", "site"],
  className: "guided-tour-nav-asset-management",
  children: [
    {
      id: "robots",
      title: <FormattedMessage id="bots" />,
      type: "item",
      icon: LocusOriginBotIcon,
      url: "asset-management/robots?site=:siteId",
      breadcrumbs: true,
      view: ["locus", "client", "site"],
      allowedGroups: [LOCUS_TENANT, CROSS_SITE_VIEWER, VIEWER],
    },
    {
      id: "chargers",
      title: <FormattedMessage id="chargers" />,
      type: "item",
      icon: LocusChargersIcon,
      url: "asset-management/chargers?site=:siteId",
      breadcrumbs: true,
      view: ["locus", "client", "site"],
      allowedGroups: [
        LOCUS_ASSET_MANAGER,
        LOCUS_CUSTOMER_USER_MANAGER,
        LOCUS_USER_MANAGER,
        SYSTEM_INTEGRATOR,
        LOCUS_TOOLS_ADMINISTRATOR,
        LOCUS_TOOLS_USER,
        LOCUS_CONFIGURATION_ADMIN,
        LOCUS_TENANT,
      ],
    },
    {
      id: "kiosks",
      title: <FormattedMessage id="kiosks" />,
      type: "item",
      icon: TvRoundedIcon,
      url: "asset-management/kiosks?site=:siteId",
      // breadcrumbs: true,
      view: ["locus", "client", "site"],
      allowedGroups: [
        LOCUS_ASSET_MANAGER,
        ASSET_MANAGER,
        LOCUS_CUSTOMER_USER_MANAGER,
        LOCUS_USER_MANAGER,
        LOCUS_TOOLS_ADMINISTRATOR,
        LOCUS_TOOLS_USER,
        LOCUS_CONFIGURATION_ADMIN,
        LOCUS_TENANT,
        CONFIGURATION_ADMIN,
        USER_MANAGER,
        TOOLS_USER,
        CROSS_SITE_VIEWER,
        VIEWER,
      ],
    },
  ],
};

export default assetManagement;
